import IntlMessages from 'Util/IntlMessages';

interface OvalButtonProps {
  label: string;
  onClick?: () => void;
  isDisabled?: boolean;
  backgroundColor?: string;
  color?: string;
  iconSet?: { src: string; srcSet: string };
}

const OvalButton = ({ label, onClick, isDisabled = false, backgroundColor = '#fff', color = '#222', iconSet }: OvalButtonProps) => {
  return (
    <div className={`oval-button ${isDisabled && 'disabled'}`} onClick={onClick} style={{ backgroundColor, color }}>
      {iconSet && <img {...iconSet} alt="icon" />}
      <IntlMessages id={label} />
    </div>
  );
};

export default OvalButton;
